import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import { stringIsNumber } from 'helpers/helpers';
import { ParameterCustomInputProps } from './types';

const ParameterNumberInput = ({
    value,
    setParameterValue,
    parameterName,
}: ParameterCustomInputProps): React.ReactElement => {
    // local state because debounce on setParameterValue disable real-time modification
    const [inputValue, setInputValue] = useState(value);
    const [isError, setIsError] = useState(false);
    const { t } = useTranslation();

    // @ts-expect-error [TS migration] Was not detected by flow
    const onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
        if (stringIsNumber(e.target.value)) {
            setIsError(false);
            setParameterValue(parameterName, Number(e.target.value));
            setInputValue(e.target.value);
        } else {
            setIsError(true);
        }
    };
    return (
        <TextField
            value={inputValue}
            onChange={onChange}
            error={isError}
            label={isError && t('errors.numberInput')}
            className="parameter-value text"
            variant="outlined"
            margin="dense"
            size="small"
        />
    );
};

export default ParameterNumberInput;
